import styled from 'styled-components';

export const ProgressBarWrapper = styled.div`
  display: flex;
  height: 10px;
  overflow: hidden;
  background-color: ${props => props.theme.colors.secondary90w};
  > div {
    width: ${props => props.value}%;
    background-color: ${props => props.theme.colors.secondary};
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: ${props => props.theme.colors.white};
    text-align: center;
    white-space: nowrap;
    transition: width 0.6s ease;
  }
`;
